import { resolvePreviewUrl } from '@/utils/preview-cache';
import { HeaderLogoControl } from './HeaderLogoControl';
import { ReportData, Psychologist } from './types';

interface ReportHeaderProps {
    data: ReportData;
    psychologist: Psychologist | null;
    /**
     * Editor-only: wraps the logo in its click-to-edit chrome. Left off by the
     * measurers, the read view and the DOCX preview, which need the header to
     * render exactly as it prints.
     */
    interactiveLogo?: boolean;
}

export function ReportHeader({ data, psychologist, interactiveLogo }: ReportHeaderProps) {
    const customizationsConfig = data.customizations;
    const headerConfig = customizationsConfig?.header;

    const logoUrl = resolvePreviewUrl(headerConfig?.logo_url);
    const alignment = headerConfig?.alignment || 'left';
    const alignmentClass =
        alignment === 'center'
            ? 'text-center items-center'
            : alignment === 'right'
              ? 'text-right items-end'
              : 'text-left items-start';

    const logoSize = headerConfig?.logo_size || 'medium';
    const logoHeightClass = logoSize === 'small' ? 'h-12' : logoSize === 'large' ? 'h-24' : 'h-16';

    const logo =
        headerConfig?.show_logo && logoUrl ? (
            <img src={logoUrl} alt="Logo" className={`${logoHeightClass} object-contain`} />
        ) : null;

    return (
        <div
            className={`mb-6 flex flex-col gap-2 pb-4 ${alignmentClass} ${
                interactiveLogo ? 'relative' : ''
            }`}
        >
            {interactiveLogo ? (
                <HeaderLogoControl
                    hasLogo={!!headerConfig?.logo_url}
                    alignment={alignment}
                    logoSize={logoSize}
                >
                    {logo}
                </HeaderLogoControl>
            ) : (
                logo
            )}
            {headerConfig?.show_psychologist_name !== false && (
                <h1 className="text-2xl font-bold text-slate-700">
                    {psychologist?.full_name || 'Nome do Psicólogo'}
                </h1>
            )}
            {headerConfig?.description?.showing && headerConfig?.description?.value && (
                <p className="text-sm text-slate-600">{headerConfig.description.value}</p>
            )}
            {headerConfig?.show_crp_number !== false && psychologist?.crp && (
                <div className="text-sm text-slate-600">CRP {psychologist.crp}</div>
            )}
        </div>
    );
}
